import { ProductRequestApprovalStatus } from "../enums/product-request-approval-status";
import { ProductRequest } from "../models/ProductRequest";

export function getApprovalRejectedProductRequestItemCount(productRequest: ProductRequest): number {
    return productRequest.items.filter(item => item.approvalStatus === ProductRequestApprovalStatus.REJECTED).length;
}